<template>
    <div>
        <apexchart type="donut" :height="height" :options="chartOptions" :series="chartSeries"></apexchart>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
    components: {
        apexchart
    },
    data: () => ({
        height: "400px"
    }),
    computed: {
        chartOptions() {
            return {
                yaxis: [{
                    borderColor: '#000000de',
                    label: {
                        borderColor: '#000000de',
                    }
                }],
                labels: this.chartLabels,
                dataLabels: {
                    enabled: true,
                    formatter: (val) => val.toFixed(2) + '%'
                },
                responsive: [{
                    options: {
                        legend: {
                            position: 'right'
                        }
                    }
                }],
                stroke: {
                    width: 1
                },
                tooltip: {
                    show: false,
                    custom: function ({series, seriesIndex, w}) {
                        return '<div class="arrow_box" style="padding: 4px;">' +
                               '<span><b>' + w.globals.labels[seriesIndex] + '<br /> Qtd. '
                                + series[seriesIndex] + '</div>'
                    },
                    fillSeriesColor: true,
                },
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'top',
                    fontSize: '13px',
                    labels: {
                        colors: '#000000de',
                        useSeriesColors: false
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '0%'
                        }
                    }
                }
            };
        },
        chartSeries() {
            return this.values.map(v => v.nrQuantidade)
        },
        chartLabels() {
            return this.values.map(v => v.dsMotivo)
        },
    },
    props: {
        values: Array,
    }
}
</script>


